webpackJsonp([14],{

/***/ 222:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 223:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 224:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 225:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 226:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 227:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 228:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 229:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 230:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 231:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["Nis"] = __webpack_require__(233);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)))

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Nis = window.Nis || {};
module.exports = Nis;

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["Page"] = __webpack_require__(235);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)))

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Page = window.Page || {};
module.exports = Page;

/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, _) {/// <reference path="vendor\jquery-1.4.1-vsdoc.js"/>
/// <reference path="Nis.js"/>

$(function () {
  Nis.Gui.init();
});

Nis.Gui = $.extend(Nis.Gui, {
  init: function () {
    Nis.Dialogs.init();
    Nis.Gui.Modal.init();
  },

  // template
  tmpl: function (template, dataObject) {
    var man = { id: '', cssclass: '', value: '', html: '', text: '' };
    dataObject = $.extend(man, dataObject);
    $.each(dataObject, function (key, val) {
      template = template.replace(new RegExp('{' + key.toString() + '}', 'g'), val == null ? '' : val.toString().replace('$0', '&#36;0'));
    });
    return template;
  },

  // shortcut to return a jquery object from a template
  $tmpl: function (template, dataObject) {
    return $(Nis.Gui.tmpl(template, dataObject));
  },

  // shortcut for creating a dropdown options
  // Nis.Gui.opt(items, true) - Will include an empty option element as the first item
  // Nis.Gui.opt(items, true, true) - Will reverse Name and Value when creating the options elements
  opt: function (data) {
    var options = '';
    var includeEmptyInFront = arguments.length >= 2 ? arguments[1] : false;
    var switchNameValue = arguments.length >= 3 ? arguments[2] : false;

    if (includeEmptyInFront) options += '<option value=""></option>';

    $.each(data, function (name, value) {
      if (switchNameValue) {
        options += '<option value="' + name + '">' + value + '</options>';
      } else {
        options += '<option value="' + value + '">' + name + '</options>';
      }
    });
    return options;
  },

  showTip: function (tipElement, atElement, tipText) {
    // make sure that the element are jquery objects
    if (tipElement.jQuery == 'undefined') tipElement = $(tipElement);
    if (atElement.jQuery == 'undefined') atElement = $(atElement);

    $(tipElement.find('.tip-content').get(0) || $('<div class="tip-content"></div>').appendTo(tipElement).get(0)).html(tipText);

    tipElement.place(atElement.offset().left, atElement.offset().top + atElement.outerHeight()).css('display', 'block');

    // todo: hide the tip after some time ?
  },

  hideTip: function (tipElement) {
    if (tipElement.jQuery == 'undefined') tipElement = $(tipElement);
    tipElement.hide();
  },

  showTinyStatus: function ($element, message, messageClass, showTime) {
    if (!$element.hasClass('tiny_message')) return;

    var validClasses = ['busy', 'success', 'error', 'info', 'warning'];
    // remove and existing class
    for (var i = 0; i < validClasses.length; i++) {
      $element.removeClass(validClasses[i]);
    }

    // clear any existing hide timer
    if ($element.data('timer') != null) {
      clearTimeout($element.data('timer'));
      $element.data('timer', null);
    }

    if (showTime != null) {
      $element.data('timer', setTimeout(function () {
        $element.fadeOut(500);
      }, showTime));
    }

    if (messageClass == 'busy') {
      $element.html('&nbsp;');
    } else {
      $element.html(message);
    }
    $element.addClass(messageClass);
    $element.css('display', 'inline-block');
  }
});

Nis.Gui.Modal = {
  level: 0,

  events: {
    CLOSED: 'closed'
  },

  init: function () {
    var m = Nis.Gui.Modal;
    $('.dialog').each(function (i, o) {
      m.make($(o), $(o).hasClass('modal'));
    });
  },

  create: function () {
    return Nis.Gui.Modal.make($("<div />").addClass("dialog"));
  },

  wrap: function ($element, title, cls) {
    var wrapper = $(Nis.Gui.tmpl('<div class="dialog"><div class="titlebar">{title}<div class="x-close closeDialog"></div></div><div class="content"></div></div>', {
      title: title ? title : ''
    }));

    if (cls) {
      wrapper.addClass(cls);
    }

    wrapper.find('.content').append($element);

    return wrapper;
  },

  make: function ($element, modal, removeOnClose, onClose) {
    $element.jqm({
      modal: modal,
      overlay: 75,
      overlayClass: 'white_overlay',
      onShow: Nis.Gui.Modal.onModalShow,
      onHide: Nis.Gui.Modal.onModalHide
    });

    // move the element
    $('body').append($element);

    $element.hide = function () {
      Nis.Gui.Modal.hide(this);
    };

    if (removeOnClose) {
      $element.on(Nis.Gui.Modal.events.CLOSED, function () {
        $element.remove();
      });
    }

    if (_.isFunction(onClose)) {
      $element.on(Nis.Gui.Modal.events.CLOSED, onClose);
    }

    return $element;
  },

  hide: function ($element) {
    $element.jqmHide();
  },

  show: function ($element) {
    $element.jqmShow();
  },

  onModalShow: function (h) {
    Nis.Gui.Modal.level += 2;
    var scrollTop = $(document).scrollTop(),
        winWidth = $(document).width(),
        width = h.w.width(),
        deltaTop = 35;

    h.w.css('top', scrollTop + deltaTop + 'px');
    h.o.css('z-index', 3002 + Nis.Gui.Modal.level - 1);
    h.w.css('z-index', 3002 + Nis.Gui.Modal.level);
    if (winWidth > width) {
      h.w.css('left', Math.floor((winWidth - width) / 2) + 'px');
    } else {
      h.w.css('left', '0px');
    }
    h.w.jqmAddClose(h.w.find('.closeDialog'));
    h.w.show();

    // try to set focus to the first form element with class defaultFocus
    if (h.w.find('.defaultFocus').length > 0) {
      h.w.find('.defaultFocus').focus();
    }
  },

  onModalHide: function (h) {
    Nis.Gui.Modal.level -= 2;
    h.w.hide();
    h.o.remove();
    h.w.trigger(Nis.Gui.Modal.events.CLOSED, h.w);
  }
};

// *** Nis.Cookies
// wrapping the jquery cookie lib (jquery.cookie)
// Work in progress
Nis.Cookies = {
  Cookie: function (cookieName, cookieValue, cookieExpire, cookieDomain) {
    this.name = cookieName;
    this.value = cookieValue;
    this.expire = cookieExpire;
    this.domain = cookieDomain;
  },
  getCookie: function (cookieName) {},
  setCookie: function (cookieName, cookieValue, cookieExpire) {},
  deleteCookie: function (cookieName) {}
};

// *** Nis.Dialogs
// Consider rewrite. This code handles the balloon style dialogs and NOT the normal dialogs (Nis.Gui.Modal)
Nis.Dialogs = {
  init: function () {
    //console.log("Init Nis.Dialogs");
  },

  managerCount: 0,

  // *** Nis.Dialogs.Dialog class
  Dialog: function (id, content, options) {
    this.id = id;
    this.content = content;

    this.pos = "relative";

    if (typeof options != "undefined") {
      this.pos = options.pos;
    }
  },

  // *** Nis.Dialogs.DialogManager class
  DialogManager: function (options) {
    var manager = this;

    this.options = {};

    this.managerId = null, this.dialogCount = 0, this.$dialog = null;
    this.$arrow = null;
    this.$content = null;

    this.dialogs = $([]); // collection of shown dialogs
    this.shownDialog = null; // shown dialog

    this.offsetX = 12;
    this.offsetY = 10;
    this.animationSpeed = 50;

    this.init = function (options) {

      this.managerId = "DialogContainer_" + Nis.Dialogs.managerCount++;

      // create the container to hold the messages
      this.$dialog = $('<div id="' + this.managerId + '" class="balloon-dialog"></div>');
      this.$arrow = $('<div class="dialog-arrow"><div class="arrow-border"></div><div class="arrow-inside"></div></div>');
      this.$content = $('<div class="dialog-content"></div>');

      this.$dialog.append(this.$arrow);
      this.$dialog.append(this.$content);
      this.$dialog.addClass('arrow-nw');

      $('body').append(this.$dialog);
    };

    this.hideDialog = function (dialog) {
      if (this.shownDialog.id == dialog.id) {
        this.$dialog.hide();
        this.shownDialog = null;
        $(document.documentElement).unbind('click', this.documentClickHandler);
      }
    };

    this.showDialog = function (dialog, callerPosition) {
      this.shownDialog = dialog;
      if (dialog.content.jQuery != 'undefined') {
        this.$content.html("").append(dialog.content); // IE needs clone here
      } else {
        this.$content.html(dialog.content);
      }

      this.$dialog.show();

      var result = this.calculateDialogPosition(dialog, callerPosition);

      this.$dialog.css({ left: result.left + "px", top: result.top + "px" });
      this.$dialog.removeClass('arrow-nw').removeClass('arrow-ne').removeClass('arrow-sw').removeClass('arrow-se').addClass('arrow-' + result.dir);

      this.$dialog.animate({ "top": "-=5px" }, this.animationSpeed);

      $(document.documentElement).bind('click', this.documentClickHandler);
    };

    this.calculateDialogPosition = function (dialog, callerPosition) {
      /*
      console.log("Click left: " + callerPosition.left);
      console.log("Click top: " + callerPosition.top);
      console.log("Window width: " + $(window).width());
      console.log("Window height: " + $(window).height());
      console.log("Window scrollTop: " + $(window).scrollTop());
      console.log("Window scrollLeft: " + $(window).scrollLeft());
      console.log("Dialog width: " + this.$dialog.width());
      console.log("Dialog height: " + this.$dialog.height());
      */

      // for balloon dialogs we need to keep the dialog within the viewport
      var result = {},
          cl = callerPosition.left,
          ct = callerPosition.top,
          dh = this.$dialog.height(),
          dw = this.$dialog.width(),
          wh = $(window).height(),
          ww = $(window).width(),
          st = $(window).scrollTop(),
          sl = $(window).scrollLeft(),
          pixelBelow = wh + st - (ct + this.offsetY),
          pixelAbove = ct - this.offsetY - st,
          pixelLeft = ww + sl - (cl + this.offsetX),
          pixelRight = cl - this.offsetX - sl;

      // check if we need to place above or below
      if (pixelBelow < dh && pixelAbove >= dh) {
        result.dir = "s";
        result.top = ct - dh - this.offsetY;
      } else {
        result.dir = "n";
        result.top = ct + this.offsetY;
      }

      if (pixelLeft < dw && pixelRight >= dw) {
        result.dir += "e";
        result.left = cl - dw;
      } else {
        result.dir += "w";
        result.left = cl - this.offsetX;
      }

      return result;
    }, this.addDialog = function ($elm, content, hover) {
      var dialogId = this.managerId + "_" + this.dialogCount++;
      var dialog = new Nis.Dialogs.Dialog(dialogId, content);

      // ***************************************************
      // todo: insert the content into a container
      // so we can reference it later without the clone!!
      // ***************************************************

      var showIt = function (event) {
        // if no dialog is shown
        if (manager.shownDialog == null) {
          manager.showDialog(dialog, { left: event.pageX, top: event.pageY });
        }
        // if a different dialog is already shown
        else if (manager.shownDialog.id != dialog.id) {
            // hide the current dialog
            manager.hideDialog(manager.shownDialog);
            manager.showDialog(dialog, { left: event.pageX, top: event.pageY });
          }
        event.stopPropagation();
        event.preventDefault();
      };

      if (hover) {
        $elm.mouseenter(function (event) {
          showIt(event);
        });
        $elm.mouseleave(function (event) {
          manager.hideDialog(manager.shownDialog);
        });
      } else $elm.click(function (event) {
        showIt(event);
      });

      return dialog;
    };

    this.addDialogWithCallback = function ($elm, contentCallback) {
      var dialogId = this.managerId + "_" + this.dialogCount++;
      var dialog = new Nis.Dialogs.Dialog(dialogId);

      $elm.click(function (event) {
        dialog.content = contentCallback(dialog);
        // if no dialog is not shown
        if (manager.shownDialog == null) {
          manager.showDialog(dialog, { left: event.pageX, top: event.pageY });
        }
        // if a different dialog is already shown
        else if (manager.shownDialog.id != dialog.id) {
            // hide the current dialog
            manager.hideDialog(manager.shownDialog);
            manager.showDialog(dialog, { left: event.pageX, top: event.pageY });
          }
        event.stopPropagation();
        event.preventDefault();
      });

      return dialog;
    };

    this.documentClickHandler = function (event) {
      if (manager.shownDialog != null && !$.contains(manager.$dialog.get(0), event.target)) {
        manager.hideDialog(manager.shownDialog);
      }
    };

    this.init();
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(4)))

/***/ }),

/***/ 611:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(612);


/***/ }),

/***/ 612:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_webagent_css_global_css__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_webagent_css_global_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_webagent_css_global_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_webagent_css_main_css__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_webagent_css_main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_webagent_css_main_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_webagent_css_webagent_css__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_webagent_css_webagent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_webagent_css_webagent_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_webagent_css_webagent_css3_css__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_webagent_css_webagent_css3_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_webagent_css_webagent_css3_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_webagent_css_webagent_user_css__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_webagent_css_webagent_user_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_webagent_css_webagent_user_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_webagent_css_global_errors_css__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_webagent_css_global_errors_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_webagent_css_global_errors_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_webagent_css_user_login_css__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_webagent_css_user_login_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_webagent_css_user_login_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_webassets_css_Reset_css__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_webassets_css_Reset_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_webassets_css_Reset_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_webassets_css_Icons_css__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_webassets_css_Icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_webassets_css_Icons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_webassets_css_Gui_css__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_webassets_css_Gui_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_webassets_css_Gui_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__css_color_scheme_css__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__css_color_scheme_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__css_color_scheme_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_expose_loader_Nis_globals_Nis__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_expose_loader_Nis_globals_Nis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_expose_loader_Nis_globals_Nis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_expose_loader_Page_globals_Page__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_expose_loader_Page_globals_Page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_expose_loader_Page_globals_Page__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_webagent_javascripts_Nis_Login__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_webagent_javascripts_Nis_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_webagent_javascripts_Nis_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_webassets_javascripts_Nis_Gui__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_webassets_javascripts_Nis_Gui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_webassets_javascripts_Nis_Gui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment_timezone__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_moment_timezone__);
















var login = new Nis.Login({
    guid: __DATA.QueryStringGuid,
    organisation: __DATA.QueryStringOrganisation,
    username: __DATA.QueryStringUsername
});
login.init($('#login-container'));
$("#userGuessedTimeZoneField").val(__WEBPACK_IMPORTED_MODULE_15_moment_timezone__["tz"].guess());
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),

/***/ 613:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 614:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {Nis = $.extend(Nis, {
  Login: function (options) {
    var service = function () {
      var self = this;

      this.events = {
        REQUEST_COMPLETE: 'request_complete'
      };

      this.operations = {
        SEND_RECOVERY_EMAIL: 'send_recovery_email',
        GET_PASSWORD_POLICY: 'get_password_policy',
        CHANGE_PASSWORD: 'change_password'
      };

      this.sendRecoveryEmail = function (organisation, username, email, callback) {
        invoke(self.operations.SEND_RECOVERY_EMAIL, { 'organisationcode': organisation, 'username': username, 'email': email }, false, callback);
      };

      this.getPasswordPolicy = function (organisation, username, guid, callback) {
        invoke(self.operations.GET_PASSWORD_POLICY, { 'organisationcode': organisation, 'username': username, 'changepasswordguid': guid }, false, callback);
      };

      this.changePassword = function (organisation, username, guid, newPassword, confirmPassword, callback) {
        invoke(self.operations.CHANGE_PASSWORD, { 'organisationcode': organisation, 'username': username, 'changepasswordguid': guid, 'newpassword': newPassword, 'confirmpassword': confirmPassword }, false, callback);
      };

      var invoke = function (operation, parameters, sync, callback) {
        var url = Nis.RootPath + 'inc/handlers/user/UserCredentials.ashx';
        var para = { 'operation': operation, 'request': JSON.stringify(parameters) };

        $.ajax({
          url: url,
          type: 'post',
          async: !sync,
          data: para,
          cache: false,
          dataType: 'json',
          success: function (json) {
            $(self).trigger(self.events.REQUEST_COMPLETE, json);
            if (callback != null && typeof callback == 'function') callback(json);
          },
          error: function (xhr) {
            throw xhr.statusText;
          }
        });
      };
    };

    var svc = new service();
    var tmpl = Nis.Gui.tmpl;
    var modal = Nis.Gui.Modal;
    var cnt = null;
    var dialog;

    var templates = {
      'DIALOG': '<div class="dialog form user-credentials"><div class="titlebar">{lbl_header}<div class="x-close closeDialog"></div></div><div class="content"><table><tr><td class="label">{lbl_organisation}</td></tr><tr><td><div class="input_wrap"><input type="text" class="input user-credentials-organisation" value="{organisation}" /></div></td></tr><tr><td class="label">{lbl_username}</td></tr><tr><td><div class="input_wrap"><input type="text" class="input user-credentials-username" value="{username}" /></div></td></tr><tr><td class="split">{lbl_splitword}</td></tr><tr><td class="label">{lbl_email}</td></tr><tr><td><div class="input_wrap"><input type="text" class="input user-credentials-email" value="" /></div></td></tr><tr><td class="user-credentials-buttons"><input type="button" value="{lbl_send}" class="user-credentials-send" /></td></tr></table></div></div>',
      'CHANGE_PASSWORD_DIALOG': '<div class="dialog form user-change-password"><div class="titlebar">{lbl_header}<div class="x-close closeDialog"></div></div><div class="content"><table><tr><td class="label">{lbl_new_password}</td></tr><tr><td><div class="input_wrap"><input type="password" class="input user-change-password-new" /></div></td></tr><tr><td class="label">{lbl_confirm_new_password}</td></tr><tr><td><div class="input_wrap"><input type="password" class="input user-change-password-confirm" /></div></td></tr><tr>{policy_container}<td class="user-change-password-buttons"><input type="button" value="{lbl_save}" class="user-change-password-save" /></td></tr></table></div></div>',
      'PASSWORD_POLICY': '<tr><td><div class="user-change-password-policy"><b>{header}</b><ul>{policy}</ul></div></td></tr>'
    };

    this.init = function (container) {
      cnt = container;

      cnt.on('click', '.recovery', function () {
        var organisation = $('#txtAgent').val();
        var username = $('#txtUsername').val();

        openDialog(organisation, username);
        return false;
      });

      if (options.username && options.organisation && options.guid) {
        svc.getPasswordPolicy(options.organisation, options.username, options.guid, function (response) {
          if (response.Success) {
            openChangePasswordDialog(response);
          } else {
            alert(response.Errors);
          }

          return false;
        });
      }
    };

    var openDialog = function (organisation, username) {
      dialog = $(tmpl(templates.DIALOG, {
        'lbl_header': Nis.Translations.forgotYourPassword,
        'lbl_organisation': Nis.Translations.organization,
        'lbl_username': Nis.Translations.username,
        'lbl_splitword': Nis.Translations.or,
        'lbl_email': Nis.Translations.email,
        'lbl_send': Nis.Translations.send,
        'organisation': organisation,
        'username': username
      }));

      modal.make(dialog, true);
      modal.show(dialog);

      dialog.on(modal.events.CLOSED, function () {
        dialog.remove();
        dialog = null;
      });

      dialog.on('click', '.user-credentials-send', function () {
        var org = dialog.find('.user-credentials-organisation').val();
        var user = dialog.find('.user-credentials-username').val();
        var email = dialog.find('.user-credentials-email').val();

        svc.sendRecoveryEmail(org, user, email, function (response) {
          if (response.Success) {
            modal.hide(dialog);
            alert(Nis.Translations.credentialsSentByEmail);
          } else {
            alert(response.Errors);
          }
        });
      });
    };

    var openChangePasswordDialog = function (data) {
      var policy = '';

      $.each(data.PasswordPolicy, function (index, item) {
        policy += '<li>' + item + '</li>';
      });

      dialog = $(tmpl(templates.CHANGE_PASSWORD_DIALOG, {
        'lbl_header': Nis.Translations.changePassword,
        'lbl_new_password': Nis.Translations.newPassword,
        'lbl_confirm_new_password': Nis.Translations.confirmNewPassword,
        'policy_container': policy != '' ? Nis.Gui.tmpl(templates.PASSWORD_POLICY, { 'header': Nis.Translations.passwordPolicy, 'policy': policy }) : policy,
        'lbl_save': Nis.Translations.save
      }));

      modal.make(dialog, true);
      modal.show(dialog);

      dialog.on(modal.events.CLOSED, function () {
        dialog.remove();
        dialog = null;
      });

      dialog.on('click', '.user-change-password-save', function () {
        var newPassword = dialog.find('.user-change-password-new').val();
        var confirmPassword = dialog.find('.user-change-password-confirm').val();

        svc.changePassword(options.organisation, options.username, options.guid, newPassword, confirmPassword, function (response) {
          if (response.Success) {
            modal.hide(dialog);
            alert(Nis.Translations.passwordChanged);
            location.href = Nis.RootPath + 'user/login.aspx';
          } else {
            alert(response.Errors);
          }
        });
      });
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ })

},[611]);


// WEBPACK FOOTER //
// page-login.js?56d5110c82aab9298f4b